import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PageDataService {
    public data: any;
    public topPromos: any;
    public whereToWatchData: any;
    public isOverlayOpen: boolean = false
    public isOverlayOpen$: BehaviorSubject<boolean>;
    public overlayVideo: string = ''
    public timeOut: any
    public swipeCountDebug1: number = 0
    public swipeCountDebug2: number = 0

    constructor() {
        this.isOverlayOpen$ = <BehaviorSubject<boolean>>new BehaviorSubject(false);

        this.topPromos = [
            {
                image: 'assets/img/top-promo/VIZIO_WATCHFREE__BANNER_MOVIESPHERE_1440x140.jpg',
                imageMob: 'assets/img/top-promo/VIZIO_WATCHFREE__BANNER_MOVIESPHERE_MOBILE.jpg',
                url: '/movie-sphere',
            },
            {
                image: 'assets/img/top-promo/VIZIO_WATCHFREE__BANNER_HERSPHERE_1440x140.jpg',
                imageMob: 'assets/img/top-promo/VIZIO_WATCHFREE__BANNER_HERSPHERE_MOBILE.jpg',
                url: '/her-sphere',
            },
            {
                image: 'assets/img/top-promo/VIZIO_WATCHFREE__BANNER_EBONYTV_1440x140.jpg',
                imageMob: 'assets/img/top-promo/VIZIO_WATCHFREE__BANNER_EBONYTV_MOBILE.jpg',
                url: '/ebonytv',
            },
        ]

        this.whereToWatchData = [
            {
                logo: 'directTv',
                items: [
                    {
                        img: 'assets/img/where-to-watch/moviesphere.jpg',
                        link: '/movie-sphere'
                    },
                    {
                        img: 'assets/img/where-to-watch/hersphere.jpg',
                        link: '/her-sphere',
                    },
                    {
                        img: 'assets/img/where-to-watch/ebonytv.jpg',
                        link: '/ebonytv',
                    },
                    {
                        img: 'assets/img/where-to-watch/are-we-there-yet-large-rectangle.jpg',
                        link: '/channel/are-we-there-yet',
                    },
                    {
                        img: 'assets/img/where-to-watch/anger-management-large-rectangle.jpg',
                        link: '/channel/anger-management',
                    },
                ]
            }, {
                logo: 'freeplay',
                items: [

                    {
                        img: 'assets/img/where-to-watch/moviesphere.jpg',
                        link: '/movie-sphere'
                    },
                    {
                        img: 'assets/img/where-to-watch/hersphere.jpg',
                        link: '/her-sphere',
                    },
                    {
                        img: 'assets/img/where-to-watch/celebrity-wedding-large-rectangle.jpg',
                        link: '/channel/celebrity-name-game',
                    },

                    {
                        img: 'assets/img/where-to-watch/are-we-there-yet-large-rectangle.jpg',
                        link: '/channel/are-we-there-yet',
                    },
                    {
                        img: 'assets/img/where-to-watch/anger-management-large-rectangle.jpg',
                        link: '/channel/anger-management',
                    },
                    {
                        img: 'assets/img/where-to-watch/ghost-hunters-large-rectangle.jpg',
                        link: '/channel/ghost-hunters',
                    },
                    {
                        img: 'assets/img/channel/designated-survivor/designated-surviovor-large-rectangle.jpg',
                        link: '/channel/designated-survivor',
                    },
                    {
                        img: 'assets/img/channel/new2/the-conners-large-rectangle.jpg',
                        link: '/channel/the-conners',
                    },
                ]
            }
        ]

        this.data = [
            {
                image: 'assets/img/where-to-watch/moviesphere.jpg',
                title: 'MovieSphere',
                link: '/movie-sphere',
                description: 'MovieSphere is the place to find blockbuster hits to indie favorites and everything in between.',
                // sizzleVideo: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2Fdec2023%2Fsizzle%2FMovieSphere_2023_Q4_TV30.mp4?alt=media&token=9893da4f-dba6-460c-b626-82ee728d60c5',
                sizzleVideo: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2F2025-q4%2Fpreview%2FMoviesphere-Q4-2025-Preview.mp4?alt=media&token=dafeca4f-f864-4d8e-b20b-9fe5124e5f5d',
                sizzleVideoLabel: 'Channel Preview',
                localLink: {
                    label: 'Watch Ad Free',
                    url: '/moviesphere-plus',
                    colorBG: '#ff5163',
                    color: '#fff'
                },
                buttons: {
                    sizzleVideoLabel: 'Channel Preview',
                    button: {
                        colorBG: '#ff5163',
                        color: "#fff",
                        label: 'TV Schedule',
                        url: '/movie-sphere',
                    },
                },
                whereToWatch: [
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/roku.png',
                        link: 'https://therokuchannel.roku.com/watch/e1192d17771c5a059930192d439957ee/moviesphere-by-lionsgate',
                    },
                    {
                        logo: 'assets/img/streaming-logos/lg-channels.png',
                        link: 'https://lgchannels.com/?dGFyZ2V0PWRldGFpbCZjaElkPU1vdmllU3BoZXJlIExHIFVTX01PVlNQTEdVU19VUyZjYWxsZXI9bGlua2NvcHk=',
                    },
                    {
                        logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                        link: 'https://play.xumo.com/live-guide/moviesphere-by-lionsgate',
                    },
                    {
                        logo: 'assets/img/streaming-logos/plex.png',
                        link: 'https://watch.plex.tv/live-tv/channel/moviesphere',
                    },
                    {
                        logo: 'assets/img/streaming-logos/tubi.png',
                        link: 'https://tubitv.com/live/400000053',
                    },

                    {
                        logo: 'assets/img/streaming-logos/pluto-tv-logo.png',
                        link: 'https://pluto.tv/en/live-tv/645e7828e1979c00087b75b4',
                    },
                    {
                        logo: 'assets/img/streaming-logos/samsungtvplus.png',
                        link: 'https://samsungtvplus.page.link/E2XvMwobRWAwoyvx7',
                    },
                    {
                        logo: 'assets/img/streaming-logos/vizio.png',
                        link: 'https://www.vizio.com/en/watchfreeplus-explore',
                    },
                    {
                        logo: 'assets/img/streaming-logos/sling-freestream-grey.png',
                        link: 'https://watch.sling.com/dashboard/home',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/vidaa.png',
                    //     link: '',
                    // },
                    {
                        logo: 'assets/img/streaming-logos/peacock.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/TCL.png',
                        link: 'https://tcltv.plus/',
                    },
                    {
                        logo: 'assets/img/streaming-logos/cw.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/philo-logo-dark.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/directv.png',
                        link: 'https://stream.directv.com/discover/network/22538f69-64c0-4ab2-99aa-9baeb5065e80',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/google-freeplay.png',
                    //     link: '',
                    // },
                    {
                        logo: 'assets/img/streaming-logos/fawesome-red.png',
                        link: 'https://fawesome.tv/home/',
                    },
                    {
                        logo: 'assets/img/streaming-logos/google-tv.png',
                        link: 'https://tv.google/intl/en_in/',
                    },

                ]
            },
            {
                image: 'assets/img/where-to-watch/50centaction.png',
                title: '50 Cent Action',
                link: '/50centaction',
                site: 'https://50centaction.com/',
                siteLabel: 'Visit Site',
                description: '50 Cent Action brings you high-octane movies and series, curated by 50 Cent himself, for the ultimate thrill ride.',
                // sizzleVideo: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2Fdec2023%2Fsizzle%2FMovieSphere_2023_Q4_TV30.mp4?alt=media&token=9893da4f-dba6-460c-b626-82ee728d60c5',
                sizzleVideo: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2F2025-q4%2F50CentAction-Q4-2025-Preview.mp4?alt=media&token=18de51a5-5298-4ce5-bc1e-eb1043250209',
                sizzleVideoLabel: 'Channel Preview',
                buttons: {
                    sizzleVideoLabel: 'Channel Preview',
                    button: {
                        colorBG: '#FE0002',
                        color: "#fff",
                        label: 'TV Schedule',
                        url: '/50centaction',
                    },
                },
                whereToWatch: [
                    
                    {
                        logo: 'assets/img/streaming-logos/roku.png',
                        link: 'https://therokuchannel.roku.com/watch/e2422e42301a3176997019f882471d77/50-cent-action',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/vizio.png',
                    //     link: '',
                    // },
                    {
                        logo: 'assets/img/streaming-logos/lg-channels.png',
                        link: 'https://lgchannels.com/?dGFyZ2V0PWRldGFpbCZjaElkPTUwY2VudGFjdGlvbl9hY3Rpb25fVVMmY2FsbGVyPWxpbmtjb3B5',
                    },
                    {
                        logo: 'assets/img/streaming-logos/vizio-watchfree-black.png',
                        link: 'https://www.vizio.com/en/watchfreeplus',
                    },
                    {
                        logo: 'assets/img/streaming-logos/sling-freestream-grey.png',
                        link: 'https://watch.sling.com/1/channel/56667fa587b04ee3a752d4066f389ab0/watch',
                    },
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: 'https://www.amazon.com/gp/video/livetv',
                    },
                    {
                        logo: 'assets/img/streaming-logos/directv.png',
                        link: 'https://www.directv.com/myfree-directv/',
                    },
                    {
                        logo: 'assets/img/streaming-logos/plex.png',
                        link: 'https://watch.plex.tv/live-tv/channel/50-cent-action',
                    },
                    {
                        logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                        link: 'https://play.xumo.com/live-guide/50-cent-action',
                    },
                    {
                        logo: 'assets/img/streaming-logos/pluto-tv-logo.png',
                        link: 'https://pluto.tv/us/live-tv/68487fb3f212bedacf5a53e3',
                    },
                    {
                        logo: 'https://lionsgatechannels.com/assets/img/streaming-logos/samsungtvplus.png',
                        link: 'https://www.samsungtvplus.com/',
                    },
                    {
                        logo: 'assets/img/streaming-logos/google-tv.png',
                        link: 'https://tv.google/intl/en_in/',
                    },
                    {
                        logo: 'assets/img/streaming-logos/philo-logo-dark.png',
                        link: 'https://www.philo.com/player/channel/Q2hhbm5lbDo2MDg1NDg4OTk2NDg0Mzk4NzQ',
                    },
                    
                ]
            },
            {
                image: 'assets/img/where-to-watch/hersphere.jpg',
                title: 'HerSphere',
                link: '/her-sphere',
                description: 'HerSphere brings together the female-driven stories you love from Lionsgate’s premium library and beyond.',
                // sizzleVideo: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2Fdec2023%2Fsizzle%2FHerSphere_2023_Q4_TV30-v2.mp4?alt=media&token=0a8538c6-740b-4eb8-aff0-1bfa78d1ade1',
                sizzleVideo: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2F2025-q4%2Fpreview%2FHersphere-Q4-2025-Preview.mp4?alt=media&token=76373988-f45a-43e6-ac03-cc9fcf799487',
                sizzleVideoLabel: 'Channel Preview',
                buttons: {
                    sizzleVideoLabel: 'Channel Preview',
                    button: {
                        colorBG: '#2efbac',
                        color: '#000',
                        label: 'TV Schedule',
                        url: '/her-sphere',
                    },
                },
                whereToWatch: [
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/roku.png',
                        link: 'https://therokuchannel.roku.com/watch/1b5062d4ed345baeaceb0f0777057d2e',
                    },
                    {
                        logo: 'assets/img/streaming-logos/lg-channels.png',
                        link: 'https://lgchannels.com/?dGFyZ2V0PWRldGFpbCZjaElkPWhlcnNwaGVyZV9tb3ZzZl9VUyZjYWxsZXI9bGlua2NvcHk=',
                    },
                    {
                        logo: 'assets/img/streaming-logos/plex.png',
                        link: 'https://watch.plex.tv/live-tv/channel/hersphere-by-lionsgate',
                    },

                    {
                        logo: 'assets/img/streaming-logos/vizio.png',
                        link: 'https://www.vizio.com/en/watchfreeplus-explore',
                    },
                    {
                        logo: 'assets/img/streaming-logos/sling-freestream-grey.png',
                        link: 'https://watch.sling.com/dashboard/home',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/vidaa.png',
                    //     link: '',
                    // },
                    {
                        logo: 'assets/img/streaming-logos/cw.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/philo-logo-dark.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/directv.png',
                        link: 'https://stream.directv.com/discover/network/a0d69095-7f3d-4780-aeb0-b49d6797c681',
                    },
                    

                ]
            },
            {
                image: 'assets/img/where-to-watch/outersphere.jpg',
                title: 'OuterSphere',
                link: '/outer-sphere',
                description: 'From superheroes to the supernatural, monsters to magicians, blockbusters to cult classics, OuterSphere has your sci-fi favorites.',
                sizzleVideo: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/outersphere-posters%2Fspring2024%2FOutersphere-Andromeda_H264.mp4?alt=media&token=dbc22ae6-37b1-4cef-ae59-d94fff403041',
                sizzleVideoLabel: 'Channel Preview',
                buttons: {
                    sizzleVideoLabel: 'Channel Preview',
                    button: {
                        colorBG: '#95e42c',
                        color: '#000',
                        label: 'TV Schedule',
                        url: '/outer-sphere',
                    },
                },
                whereToWatch: [
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                        link: 'https://play.xumo.com/live-guide/outersphere-by-lionsgate',
                    },
                    {
                        logo: 'assets/img/streaming-logos/tubi.png',
                        link: 'https://tubitv.com/live/400000006',
                    },
                    {
                        logo: 'assets/img/streaming-logos/samsungtvplus.png',
                        link: 'https://samsungtvplus.page.link/vpAeBG3P292meDFAA',
                    },
                    {
                        logo: 'assets/img/streaming-logos/plex.png',
                        link: 'https://watch.plex.tv/live-tv/channel/outersphere-by-lionsgate',
                    },
                    {
                        logo: 'assets/img/streaming-logos/sling-freestream-grey.png',
                        link: 'https://watch.sling.com/dashboard/home',
                    },
                    {
                        logo: 'assets/img/streaming-logos/cw.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/philo-logo-dark.png',
                        link: '',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/vidaa.png',
                    //     link: '',
                    // },
                    {
                        logo: 'assets/img/streaming-logos/vizio.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/fawesome-red.png',
                        link: 'https://fawesome.tv/home/',
                    },
                ]
            },
            {
                image: 'assets/img/where-to-watch/ebonytv.jpg',
                title: 'Ebony TV',
                link: '/ebonytv',
                description: 'EBONY TV by Lionsgate offers premium curated content that includes award-winning films, engaging comedies, and groundbreaking series that celebrate the global richness of Black culture.',
                // sizzleVideo: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2Febony-tv-q4%2FEbony_TV_Q4_2024.mp4?alt=media&token=a6843156-885e-47f6-8a8d-4e8e5ebbb892',
                sizzleVideo: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2F2025-q4%2Fpreview%2FEbonyTV-Q4-2025-Preview.mp4?alt=media&token=59723c9c-d0a3-4fcc-8202-99e424416ab6',
                sizzleVideoLabel: 'Channel Preview',
                buttons: {
                    sizzleVideoLabel: 'Channel Preview',
                    button: {
                        colorBG: '#e02b2e',
                        color: '#fff',
                        label: 'TV Schedule',
                        url: '/ebonytv',
                    },
                },
                whereToWatch: [
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/roku.png',
                        link: 'https://therokuchannel.roku.com/watch/d0c6ac240cb8529992ee3340e5b7f102/ebony',
                    },
                    {
                        logo: 'assets/img/streaming-logos/lg-channels.png',
                        link: 'https://lgchannels.com/?dGFyZ2V0PWRldGFpbCZjaElkPWVib255dHZ0dWJpX212c2JrX1VTJmNhbGxlcj1saW5rY29weQ==',
                    },
                    {
                        logo: 'assets/img/streaming-logos/tubi.png',
                        link: 'https://tubitv.com/live/400000056',
                    },
                    {
                        logo: 'assets/img/streaming-logos/samsungtvplus.png',
                        link: 'https://samsungtvplus.page.link/vmUkmhjbn4S93opD6',
                    },
                    {
                        logo: 'assets/img/streaming-logos/plex.png',
                        link: 'https://watch.plex.tv/live-tv/channel/ebony-tv-by-lionsgate',
                    },
                    {
                        logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                        link: 'https://play.xumo.com/live-guide/ebony-tv-by-lionsgate',
                    },
                    {
                        logo: 'assets/img/streaming-logos/vizio.png',
                        link: 'https://www.vizio.com/en/watchfreeplus-explore',
                    },
                    {
                        logo: 'assets/img/streaming-logos/sling-freestream-grey.png',
                        link: 'https://watch.sling.com/dashboard/home',
                    },
                    {
                        logo: 'assets/img/streaming-logos/peacock.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/cw.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/philo-logo-dark.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/pluto-tv-logo.png',
                        link: 'https://pluto.tv/us/live-tv/6675c713fc3a46000863dde7',
                    },
                    {
                        logo: 'assets/img/streaming-logos/directv.png',
                        link: 'https://stream.directv.com/discover/network/85403cde-ae54-4bde-9257-bd72435e8738',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/google-freeplay.png',
                    //     link: '',
                    // },
                    {
                        logo: 'assets/img/streaming-logos/fawesome-red.png',
                        link: 'https://fawesome.tv/home/',
                    },
                    {
                        logo: 'assets/img/streaming-logos/google-tv.png',
                        link: 'https://tv.google/intl/en_in/',
                    },
                ]
            },
            {
                image: 'assets/img/where-to-watch/lawless-v3.png',
                title: 'Lawless',
                link: '/lawless',
                description: 'Dive into the criminal underworld where justice is a game, and the stakes are high.',
                // sizzleVideo: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2Fdec2023%2Fsizzle%2FMovieSphere_2023_Q4_TV30.mp4?alt=media&token=9893da4f-dba6-460c-b626-82ee728d60c5',
                sizzleVideo: '',
                sizzleVideoLabel: '',
                buttons: {
                    sizzleVideoLabel: '',
                    button: {
                        colorBG: '#895614',
                        color: '#fff',
                        label: 'TV Schedule',
                        url: '/lawless',
                    },
                },
                whereToWatch: [
                    {
                        logo: 'assets/img/streaming-logos/lg-channels.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/philo-logo-dark.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/plex.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/sling-freestream-grey.png',
                        link: 'https://watch.sling.com/1/asset/3a9a368c1a34d048904e555577330c48/watch',
                    },
                    {
                        logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                        link: 'https://play.xumo.com/live-guide/lawless-by-lionsgate',
                    },
                    {
                        logo: 'assets/img/streaming-logos/fubo.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/google-tv.png',
                        link: 'https://tv.google/intl/en_in/',
                    },
                    {
                        logo: 'assets/img/streaming-logos/TCL.png',
                        link: 'https://tcltv.plus/',
                    },
                    {
                        logo: 'assets/img/streaming-logos/fawesome-red.png',
                        link: '',
                    },
                ]
            },
            {
                image: 'assets/img/extreme-jobs/Extreme-Jobs-where-to-watch.jpg',
                title: 'Extreme Jobs',
                link: '/extreme-jobs',
                description: 'Experience thrilling gold rushes, high seas drama, masterful log home builds, dedicated animal care in the Scottish Highlands, and adrenaline-pumping storm chases. Every show is an adventure.',
                // sizzleVideo: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2Fdec2023%2Fsizzle%2FMovieSphere_2023_Q4_TV30.mp4?alt=media&token=9893da4f-dba6-460c-b626-82ee728d60c5',
                sizzleVideo: '',
                sizzleVideoLabel: '',
                buttons: {
                    sizzleVideoLabel: '',
                    button: {
                        colorBG: '#678e8e',
                        color: '#fff',
                        label: 'TV Schedule',
                        url: '/extreme-jobs',
                    },
                },
                whereToWatch: [
                    {
                        logo: 'assets/img/streaming-logos/roku.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/plex.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/sling-freestream-grey.png',
                        link: 'https://watch.sling.com/1/asset/48d9ed593207d3aba0346a4982914cae/watch',
                    },
                    {
                        logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                        link: 'https://play.xumo.com/live-guide/extreme-jobs',
                    },
                    {
                        logo: 'assets/img/streaming-logos/google-tv.png',
                        link: 'https://tv.google/intl/en_in/',
                    },
                    {
                        logo: 'assets/img/streaming-logos/TCL.png',
                        link: 'https://tcltv.plus/',
                    },

                ]
            },
            {
                image: 'assets/img/home/logos/moviesphere-gold-large.jpg',
                title: 'MovieSphere Gold',
                link: null,
                external: true,
                site: 'https://MovieSphereGold.com',
                siteLabel: "Visit Site",
                description: 'MovieSphere Gold is a contemporary movie network, delivering premium films backed by Lionsgate. With exclusive themed marathons, fan-favorite hits, and titles you won’t see anywhere else, we’re your ultimate movie destination. <br><br><br>',
                // sizzleVideo: 'https://firebasestorage.googleapis.com/v0/b/lionsgatesphere.appspot.com/o/home%2Fdec2023%2Fsizzle%2FMovieSphere_2023_Q4_TV30.mp4?alt=media&token=9893da4f-dba6-460c-b626-82ee728d60c5',
                sizzleVideo: '',
                sizzleVideoLabel: '',
                buttons: {
                    sizzleVideoLabel: '',
                    button: {
                        external: true,
                        colorBG: '#976E3A',
                        color: '#fff',
                        label: 'TV Schedule',
                        url: 'https://MovieSphereGold.com/schedule',
                    },
                },
                whereToWatch: [
                ]
            },
            {
                image: 'assets/img/moviesphere-plus/moviesphere-plus-large.jpg',
                title: 'MovieSphere+',
                link: '/moviesphere-plus',
                external: false,
                site: 'https://www.amazon.com/gp/video/channel/5b5d8c9f-01f7-4916-b20f-53ea0a51b51e',
                siteLabel: "Start Your Free Trial",
                description: 'MovieSphere+ is the place to find hits to cult classics and everything in between. Ad Free. On Demand. <br>',
                sizzleVideo: '',
                sizzleVideoLabel: '',
                buttons: {
                    sizzleVideoLabel: '',
                    button: {
                        external: true,
                        colorBG: '#3117D0',
                        color: '#fff',
                        label: 'TV Schedule',
                        url: 'https://MovieSphereGold.com/schedule',
                    },
                },
                availableOn: {
                    label: 'Available on:',
                    platforms: [
                        {
                            url: 'https://www.amazon.com/gp/video/channel/5b5d8c9f-01f7-4916-b20f-53ea0a51b51e',
                            image: 'assets/img/moviesphere-plus/prime-video-button-desktop.png',
                            imageOver: 'assets/img/moviesphere-plus/prime-video-button-rollover-desktop.png',
                            alt: 'Prime Video',
                        },
                        {
                            url: 'https://www.youtube.com/@MovieSphereChannel/featured',
                            image: 'assets/img/moviesphere-plus/youtube-button-desktop.png',
                            imageOver: 'assets/img/moviesphere-plus/youtube-button-rollover-desktop.png',
                            alt: 'YouTube',
                        },
                    ]
                },
                whereToWatch: [
                ]
            },
            {
                image: 'assets/img/lionsgateplus/lionsgate-plus.jpg',
                title: 'Lionsgate+',
                link: 'https://lionsgateplus.com/',
                external: true,
                site: 'https://www.amazon.com/gp/video/channel/c1efd0a7-cefe-db33-3693-6099f26ccf1a',
                siteLabel: "Start Your Free Trial",
                description: 'From the studio behind iconic dramas, hit action franchises, beloved comedies and more, Lionsgate+ is the streaming home for the stories you live in.',
                sizzleVideo: '',
                sizzleVideoLabel: '',
                buttons: {
                    sizzleVideoLabel: '',
                    button: {
                        external: true,
                        colorBG: '#2c0136',
                        color: '#fff',
                        label: 'TV Schedule',
                        url: 'https://MovieSphereGold.com/schedule',
                    },
                },
                availableOn: {
                    label: 'Available on:',
                    platforms: [
                        {
                            url: 'https://www.amazon.com/gp/video/channel/c1efd0a7-cefe-db33-3693-6099f26ccf1a',
                            image: 'assets/img/moviesphere-plus/prime-video-button-desktop.png',
                            imageOver: 'assets/img/moviesphere-plus/prime-video-button-rollover-desktop.png',
                            alt: 'Prime Video',
                        },
                    ]
                },
                whereToWatch: [
                ]
            },
            {
                image: 'assets/img/channel/designated-survivor/designated-surviovor-large-rectangle.jpg',
                title: 'Designated Survivor',
                link: '/channel/designated-survivor',
                description: 'Tom Kirkman, a low-level cabinet member, is unexpectedly catapulted to the presidency after a catastrophic attack during the State of the Union address kills everyone above him in the line of succession.',
                whereToWatch: [
                    {
                        logo: 'assets/img/streaming-logos/roku.png',
                        link: 'https://therokuchannel.roku.com/watch/8b6e781730caa4afe9bd288a8b880c40/designated-survivor',
                    },
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: 'https://www.amazon.com/gp/video/storefront/ref=atv_gst_GettingStarted_c_9zZ8D2_live?contentType=home&contentId=live',
                    },

                    {
                        logo: 'assets/img/streaming-logos/plex.png',
                        link: 'https://watch.plex.tv/live-tv/channel/designated-survivor',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/google-freeplay.png',
                    //     link: '',
                    // },
                    // {
                    //     logo: 'assets/img/streaming-logos/lg-channels.png',
                    //     link: '',
                    // },
                    // {
                    //     logo: 'assets/img/streaming-logos/vizio.png',
                    //     link: '',
                    // },
                    {
                        logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/google-tv.png',
                        link: 'https://tv.google/intl/en_in/',
                    },
                    {
                        logo: 'assets/img/streaming-logos/philo-logo-dark.png',
                        link: '',
                    },
                ]
            },
            {
                image: 'assets/img/channel/new2/the-conners-large-rectangle.jpg',
                title: 'The Conners',
                link: '/channel/the-conners',
                description: 'The Conners grapple with parenthood, dating, financial pressures, aging and in-laws in working-class America.',
                whereToWatch: [
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: '',
                    },




                    {
                        logo: 'assets/img/streaming-logos/plex.png',
                        link: 'https://watch.plex.tv/en/live-tv/channel/the-conners',
                    },
                    {
                        logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                        link: '',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/google-freeplay.png',
                    //     link: '',
                    // },
                    {
                        logo: 'assets/img/streaming-logos/tubi.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/vizio.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/google-tv.png',
                        link: 'https://tv.google/intl/en_in/',
                    },
                ]
            },

            {
                image: 'assets/img/channel/new2/nash-bridges-large-rectangle.jpg',
                title: 'Nash Bridges',
                link: '/channel/nash-bridges',
                description: 'Don Johnson is Nash Bridges, a San Francisco police investigator who deserves his reputation as the city’s top cop.',
                whereToWatch: [
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: '',
                    },


                    {
                        logo: 'assets/img/streaming-logos/lg-channels.png',
                        link: 'https://lgchannels.com/?dGFyZ2V0PWRldGFpbCZjaElkPW5hc2hicmlkZ2VzX25iZGdzX1VTJmNhbGxlcj1saW5rY29weQ==',
                    },

                    {
                        logo: 'assets/img/streaming-logos/plex.png',
                        link: 'https://watch.plex.tv/live-tv/channel/nash-bridges',
                    },
                    {
                        logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/pluto-tv-logo.png',
                        link: 'https://pluto.tv/us/live-tv/6675c742ca74680008566b88',
                    },
                    {
                        logo: 'assets/img/streaming-logos/tubi.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/fawesome-red.png',
                        link: 'https://fawesome.tv/home/',
                    },
                ]
            },
            // {
            //     image: 'assets/img/channel/new2/grace-and-frankie-large-rectangle.jpg',
            //     title: 'Grace and Frankie',
            //     link: '/channel/grace-and-frankie',
            //     description: 'They’re not friends, but when their husbands leave them for each other, proper Grace and eccentric Frankie begin to bond.',
            //     whereToWatch: [
            //         {
            //             logo: 'assets/img/streaming-logos/prime-video.png',
            //             link: '',
            //         },
            //         {
            //             logo: 'assets/img/streaming-logos/plex.png',
            //             link: 'https://watch.plex.tv/en/live-tv/channel/grace-and-frankie',
            //         },

            //     ]
            // },
            {
                image: 'assets/img/where-to-watch/are-we-there-yet-large-rectangle.jpg',
                title: 'Are We There Yet?',
                link: '/channel/are-we-there-yet',
                description: 'ARE WE THERE YET? revolves around the recently blended Kingston-Person family as they work to adapt to their new family dynamics.',
                whereToWatch: [
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/tubi.png',
                        link: 'https://tubitv.com/live/682057',
                    },

                    {
                        logo: 'assets/img/streaming-logos/lg-channels.png',
                        link: 'https://lgchannels.com/?dGFyZ2V0PWRldGFpbCZjaElkPWFyZXdldGhlcmV5ZXRsZ3VzX3J3dGh5dGxndXNfVVMmY2FsbGVyPWxpbmtjb3B5',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/vidaa.png',
                    //     link: '',
                    // },
                    {
                        logo: 'assets/img/streaming-logos/plex.png',
                        link: 'https://watch.plex.tv/live-tv/channel/are-we-there-yet',
                    },
                    {
                        logo: 'assets/img/streaming-logos/roku.png',
                        link: 'https://therokuchannel.roku.com/watch/1c235612cec3540f85bb5e2bf7982047',
                    },
                    {
                        logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                        link: 'https://play.xumo.com/live-guide/are-we-there-yet',
                    },

                    {
                        logo: 'assets/img/streaming-logos/vizio.png',
                        link: 'https://www.vizio.com/en/watchfreeplus-explore',
                    },
                    {
                        logo: 'assets/img/streaming-logos/sling-freestream-grey.png',
                        link: 'https://watch.sling.com/dashboard/home',
                    },
                    {
                        logo: 'assets/img/streaming-logos/TCL.png',
                        link: 'https://tcltv.plus/',
                    },
                    {
                        logo: 'assets/img/streaming-logos/cw.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/philo-logo-dark.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/directv.png',
                        link: 'https://stream.directv.com/discover/network/596e5131-0fd0-407b-ac07-b8b41f081212',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/google-freeplay.png',
                    //     link: '',
                    // },
                    {
                        logo: 'assets/img/streaming-logos/google-tv.png',
                        link: 'https://tv.google/intl/en_in/',
                    },
                ]
            },
            {
                image: 'assets/img/where-to-watch/anger-management-large-rectangle.jpg',
                title: 'Anger Management',
                link: '/channel/anger-management',
                description: 'Charlie Sheen stars as “Charlie,” a non-traditional therapist specializing in angermanagement while still battling his own anger issues.',
                whereToWatch: [
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/tubi.png',
                        link: 'https://tubitv.com/live/682059',
                    },

                    {
                        logo: 'assets/img/streaming-logos/lg-channels.png',
                        link: 'https://lgchannels.com/?dGFyZ2V0PWRldGFpbCZjaElkPWFuZ2VybWFuYWdlbWVudF9sZ252YnBfVVMmY2FsbGVyPWxpbmtjb3B5',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/vidaa.png',
                    //     link: '',
                    // },
                    {
                        logo: 'assets/img/streaming-logos/plex.png',
                        link: 'https://watch.plex.tv/live-tv/channel/anger-management',
                    },
                    {
                        logo: 'assets/img/streaming-logos/roku.png',
                        link: 'https://therokuchannel.roku.com/watch/7fbae583c30451e989ea55b4c605e8a9/anger-management',
                    },
                    {
                        logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                        link: 'https://play.xumo.com/live-guide/anger-management-channel',
                    },

                    {
                        logo: 'assets/img/streaming-logos/vizio.png',
                        link: 'https://www.vizio.com/en/watchfreeplus-explore',
                    },
                    {
                        logo: 'assets/img/streaming-logos/sling-freestream-grey.png',
                        link: 'https://watch.sling.com/dashboard/home',
                    },
                    {
                        logo: 'assets/img/streaming-logos/cw.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/philo-logo-dark.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/directv.png',
                        link: 'https://stream.directv.com/discover/network/02f7f31d-7870-4519-aebd-9fdeab18c4b4',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/google-freeplay.png',
                    //     link: '',
                    // },
                    {
                        logo: 'assets/img/streaming-logos/google-tv.png',
                        link: 'https://tv.google/intl/en_in/',
                    },
                ]
            },
            {
                image: 'assets/img/where-to-watch/ghost-hunters-large-rectangle.jpg',
                title: 'Ghost Hunters',
                link: '/channel/ghost-hunters',
                description: 'Follow the Ghost Hunters team as they cross the country searching for answers in the nation\'s most haunted locations.',
                whereToWatch: [
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/pluto-tv-logo.png',
                        link: 'https://pluto.tv/en/live-tv/64e561a4354251000823a0e0',
                    },

                    {
                        logo: 'assets/img/streaming-logos/lg-channels.png',
                        link: 'https://lgchannels.com/?dGFyZ2V0PWRldGFpbCZjaElkPWdob3N0aHVudGVyc19ndGh0cl9VUyZjYWxsZXI9bGlua2NvcHk=',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/vidaa.png',
                    //     link: '',
                    // },
                    {
                        logo: 'assets/img/streaming-logos/plex.png',
                        link: 'https://watch.plex.tv/live-tv/channel/ghost-hunters-channel',
                    },
                    {
                        logo: 'assets/img/streaming-logos/roku.png',
                        link: 'https://therokuchannel.roku.com/watch/e3a9171a7b9155ca89ba9f7f3e1a6bde/ghost-hunters',
                    },
                    {
                        logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                        link: 'https://play.xumo.com/live-guide/ghost-hunters-channel',
                    },
                    {
                        logo: 'assets/img/streaming-logos/vizio.png',
                        link: 'https://www.vizio.com/en/watchfreeplus-explore',
                    },
                    {
                        logo: 'assets/img/streaming-logos/sling-freestream-grey.png',
                        link: 'https://watch.sling.com/dashboard/home',
                    },
                    {
                        logo: 'assets/img/streaming-logos/peacock.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/cw.png',
                        link: '',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/google-freeplay.png',
                    //     link: '',
                    // },
                    {
                        logo: 'assets/img/streaming-logos/fawesome-red.png',
                        link: 'https://fawesome.tv/home/',
                    },
                    {
                        logo: 'assets/img/streaming-logos/google-tv.png',
                        link: 'https://tv.google/intl/en_in/',
                    },
                ]
            },
            {
                image: 'assets/img/where-to-watch/wanted-dead-or-alive-large-rectangle.jpg',
                title: 'Wanted: Dead or Alive',
                link: '/channel/wanted-dead-or-alive',
                description: 'A Civil War veteran with a sawed-off rifle makes a living as a bounty hunter in the Wild West.',
                whereToWatch: [
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/pluto-tv-logo.png',
                        link: 'https://pluto.tv/en/live-tv/6089788de5c8410007808e26',
                    },
                    {
                        logo: 'assets/img/streaming-logos/tubi.png',
                        link: 'https://tubitv.com/live/680705',
                    },

                    {
                        logo: 'assets/img/streaming-logos/lg-channels.png',
                        link: '',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/vidaa.png',
                    //     link: '',
                    // },
                    {
                        logo: 'assets/img/streaming-logos/roku.png',
                        link: 'https://therokuchannel.roku.com/details/f12650ab1d2a584a8bf71dd98a6a1964/wanted-dead-or-alive',
                    },
                    {
                        logo: 'assets/img/streaming-logos/plex.png',
                        link: 'https://watch.plex.tv/live-tv/channel/wanted-dead-or-alive',
                    },
                    {
                        logo: 'assets/img/streaming-logos/sling-freestream-grey.png',
                        link: 'https://watch.sling.com/dashboard/home',
                    },
                    {
                        logo: 'assets/img/streaming-logos/cw.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/google-tv.png',
                        link: 'https://tv.google/intl/en_in/',
                    },

                ]
            },
            {
                image: 'assets/img/where-to-watch/celebrity-wedding-large-rectangle.jpg',
                title: 'Celebrity Name Game',
                link: '/channel/celebrity-name-game',
                description: 'Celebrities join contestants as they improvise clues to identify as many correct answers as possible.',
                whereToWatch: [
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/roku.png',
                        link: 'https://therokuchannel.roku.com/watch/23427355f7f35851b75a210d7cca22a4',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/vidaa.png',
                    //     link: '',
                    // },
                    {
                        logo: 'assets/img/streaming-logos/plex.png',
                        link: 'https://watch.plex.tv/live-tv/channel/celebrity-name-game',
                    },
                    {
                        logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                        link: 'https://play.xumo.com/live-guide/the-celebrity-name-game-channel',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/vizio.png',
                    //     link: 'https://www.vizio.com/en/watchfreeplus-explore',
                    // },
                    {
                        logo: 'assets/img/streaming-logos/sling-freestream-grey.png',
                        link: 'https://watch.sling.com/dashboard/home',
                    },
                    {
                        logo: 'assets/img/streaming-logos/cw.png',
                        link: '',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/google-freeplay.png',
                    //     link: '',
                    // },
                    {
                        logo: 'assets/img/streaming-logos/google-tv.png',
                        link: 'https://tv.google/intl/en_in/',
                    },
                ]
            },
            {
                image: 'assets/img/where-to-watch/caught-in-providence-large-rectangle.jpg',
                title: 'Caught In Providence',
                link: '/channel/caught-in-providence',
                description: 'Judge Frank Caprio takes an empathetic approach to a variety of traffic, parking and other violations.',
                whereToWatch: [
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/tubi.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/roku.png',
                        link: 'https://therokuchannel.roku.com/watch/bef128703a8054fda8316678b6a0daff',
                    },
                    {
                        logo: 'assets/img/streaming-logos/plex.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/sling-freestream-grey.png',
                        link: 'https://watch.sling.com/dashboard/home',
                    },
                    {
                        logo: 'assets/img/streaming-logos/cw.png',
                        link: '',
                    },
                ]
            },








            {
                image: 'assets/img/where-to-watch/nashville-large-rectangle.jpg',
                title: 'Nashville',
                link: '/channel/nashville',
                description: 'Nashville follows the lives and tragedies of rising and fading country music stars in Nashville, Tennessee.',
                whereToWatch: [
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/tubi.png',
                        link: 'https://tubitv.com/live/400000010',
                    },

                    {
                        logo: 'assets/img/streaming-logos/lg-channels.png',
                        link: 'https://lgchannels.com/?dGFyZ2V0PWRldGFpbCZjaElkPW5hc2h2aWxsZWVuZ2xpc2hfbGdhdGVfVVMmY2FsbGVyPWxpbmtjb3B5',
                    },
                    // {
                    //     logo: 'assets/img/streaming-logos/vidaa.png',
                    //     link: '',
                    // },
                    {
                        logo: 'assets/img/streaming-logos/plex.png',
                        link: 'https://watch.plex.tv/live-tv/channel/nashville',
                    },
                    {
                        logo: 'assets/img/streaming-logos/sling-freestream-grey.png',
                        link: 'https://watch.sling.com/dashboard/home',
                    },
                    {
                        logo: 'assets/img/streaming-logos/cw.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/philo-logo-dark.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/fawesome-red.png',
                        link: 'https://fawesome.tv/home/',
                    },
                ]
            },
            
            {
                image: 'assets/img/home/love-thy-neighbor-large-rectangle.jpg',
                title: 'Love Thy Neighbor',
                link: '/channel/love-thy-neighbor',
                description: 'Tyler Perry’s feel-good sitcom set in a family-run diner, where outspoken Hattie Mae Love dishes out laughs, love, and life lessons.',
                whereToWatch: [
                    {
                        logo: 'assets/img/streaming-logos/sling-freestream-grey.png',
                        link: 'https://watch.sling.com/1/asset/3c1a8f959de4d7f98b0dde06d99c100c/watch',
                    },
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/roku.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/lg-channels.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/vizio.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/philo-logo-dark.png',
                        link: '',
                    },
                ]
            },
            {
                image: 'assets/img/home/wendy-williams-large-rectangle.jpg',
                title: 'Wendy Williams Show',
                link: '/channel/wendy-williams',
                description: 'The iconic Wendy Williams talk show delivers bold, unfiltered entertainment with celebrity gossip, hot topics, hilarious moments, and unforgettable interviews.',
                whereToWatch: [
                    {
                        logo: 'assets/img/streaming-logos/sling-freestream-grey.png',
                        link: 'https://watch.sling.com/1/asset/77a566271661d38796d44946b66c112d/watch',
                    },
                    {
                        logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                        link: 'https://play.xumo.com/live-guide/wendy-williams',
                    },
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/google-tv.png',
                        link: 'https://tv.google/intl/en_in/',
                    },
                ]
            },
            {
                image: 'assets/img/home/weeds-nurse-jackie-large-rectangle.jpg',
                title: 'Weeds & Nurse Jackie',
                link: '/channel/weeds-and-nurse-jackie',
                description: 'Dive into the chaotic, darkly witty worlds of suburban drug dealer Nancy Botwin and pill-popping nurse Jackie Peyton. Gritty, sharp, and addictively entertaining.',
                whereToWatch: [
                    {
                        logo: 'assets/img/streaming-logos/sling-freestream-grey.png',
                        link: 'https://watch.sling.com/1/asset/017cb18e66c2de14882d3eb83aeebf6f/watch',
                    },
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/plex.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/philo-logo-dark.png',
                        link: '',
                    },

                ]
            },
            {
                image: 'assets/img/channel/heartland/heartland-large-rectangle.jpg',
                title: 'Heartland',
                link: '/channel/heartland',
                description: 'Saddle up and ride the highs and lows of ranch life with Amy, Lou and the rest of the family.',
                whereToWatch: [
                    {
                        logo: 'assets/img/streaming-logos/roku.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/pluto-tv-logo.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/lg-channels.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/vizio.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/philo-logo-dark.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/plex.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/sling-freestream-grey.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/xumo-play-logo.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/TCL.png',
                        link: '',
                    },
                ]
            },
            {
                image: 'assets/img/channel/wicked-tuna/wicked-tuna-large-rectangle.jpg',
                title: 'Wicked Tuna',
                link: '/channel/wicked-tuna',
                description: 'A group of fishermen in Gloucester, Mass., hauls in bluefin tuna, risking danger on the high seas.',
                whereToWatch: [
                    {
                        logo: 'assets/img/streaming-logos/roku.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/pluto-tv-logo.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/lg-channels.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/prime-video.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/plex.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/sling-freestream-grey.png',
                        link: '',
                    },
                    {
                        logo: 'assets/img/streaming-logos/TCL.png',
                        link: '',
                    },
                ]
            },


            




        ]
    }

    increasSswipeCountDebug1() {
        this.swipeCountDebug1++
    }
    
    increasSswipeCountDebug2() {
        this.swipeCountDebug2++
    }

    get(path): any {
        return this.data.find((item) => item.link == path)
    }

    openOverlay(path: string) {
        let data = this.get(path)

        clearTimeout(this.timeOut)
        this.overlayVideo = data.sizzleVideo
        this.isOverlayOpen = true
        this.isOverlayOpen$.next(this.isOverlayOpen)
    }

    closeOverlay() {
        clearTimeout(this.timeOut)
        this.isOverlayOpen = false
        this.isOverlayOpen$.next(this.isOverlayOpen)
        this.timeOut = setTimeout(() => {
            this.overlayVideo = ''
        }, 10)
    }
}
